import type { ReactNode } from 'react';

interface KbdProps {
  children: ReactNode;
  /** Its key was just pressed: the cap dips. */
  hit?: boolean;
}

/** A key cap in the search's hints. */
export function Kbd({ children, hit = false }: KbdProps) {
  return (
    <kbd
      data-hit={hit || undefined}
      className="inline-grid h-[18px] min-w-[18px] place-items-center rounded-[5px] border border-b-2 border-solid border-v2-border bg-v2-neutral-surface px-[5px] font-sans text-[10.5px] font-medium leading-none text-v2-text-secondary transition-[translate,color] duration-100 data-[hit]:translate-y-px data-[hit]:text-v2-text-primary dark:border-v2-btn-secondary-2 dark:bg-v2-surface-tertiary"
    >
      {children}
    </kbd>
  );
}
